import {Inject, Pipe, PipeTransform} from '@angular/core';
import {FonctionUtiles} from "../../utils/fonctionsUtiles";

@Pipe({
  name: 'recettes'
})





export class Recettes implements PipeTransform {

  constructor(private fonctionUtils: FonctionUtiles) {

  }
  transform(tickets:any): any {
    return this.fonctionUtils.calculOrganizerRecette(tickets);
  }
}
